// extracted by mini-css-extract-plugin
export default {"pagination":"OrdersPagination_pagination__HUhSQ","arrow":"OrdersPagination_arrow__GOhxb","label":"OrdersPagination_label__tLHSe"};